import { useEffect, useContext } from "react";
import { useCambioInstalacion } from "./useCambioInstalacion";
import { DataContext } from "../../contextData/contextData";
import ErrorInput from "../../components/ui/ErrorInput";
import { InputSelect } from "../../components/formComponents/inputSelect";

export const CambioDeInstalacion = (props) => {
  const { unidadesNegocio, getUnidadesNegocio, instalaciones, getInstalaciones } = useCambioInstalacion();
  const { uno } = useContext(DataContext);
  const { formik } = props;

  useEffect(() => {
    console.log(instalaciones);
  }, [instalaciones]);

  useEffect(() => {
    if (formik.values.unidad_destino) {
      getInstalaciones(formik.values.unidad_destino);
    }
  }, [formik.values.unidad_destino]);

  useEffect(() => {
    getUnidadesNegocio();
  }, []);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <label htmlFor="unidad_destino">Unidad de negocio *</label>
          {formik.errors.unidad_destino !== undefined && formik.touched.unidad_destino !== undefined && (
            <ErrorInput touched={formik.touched.unidad_destino} error={formik.errors.unidad_destino} />
          )}
        </div>

        <select
          disabled={!formik.values.fecha_inicio_cambio || formik.errors.fecha_inicio_cambio}
          id="unidadNegocio"
          className="form-select"
          name="unidad_destino"
          aria-label="Default select example"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.unidad_destino}
        >
          <option value="">Seleccione</option>
          {unidadesNegocio.map((el, idx) => (
            <option value={el.id} key={idx}>
              {el.nombre}
            </option>
          ))}
        </select>
      </div>
      <div>








        <div className="d-flex justify-content-between">
          <label htmlFor="instalacion_administrador">Instalación *</label>
          {formik.errors.instalacion_administrador !== undefined && formik.touched.instalacion_administrador !== undefined && (
            <ErrorInput touched={formik.touched.instalacion_administrador} error={formik.errors.instalacion_administrador} />
          )}
        </div>
        <InputSelect
          llave_texto="NOMBRE_UO"
          id="instalacion_administrador"
          llave_valor={null}
          formik={formik}
          arr={instalaciones}
        />

        {/* <select
          disabled={!formik.values.fecha_inicio_cambio || formik.errors.fecha_inicio_cambio}
          id="instalacion_administrador"
          className="form-select"
          name="instalacion_administrador"
          aria-label="Default select example"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.instalacion_administrador}
        >
          <option value="">Seleccione</option>
          {instalaciones.map((el, idx) => (
            <option
              value={JSON.stringify(el)}
              key={idx}
              className={`${[el["JEFE"], el["ADMIN"], el["REVISOR_RRHH"]].includes(null) ? "text-desactivado" : ""}`}
            >
              {el["NOMBRE_UO"]}
            </option>
          ))}
        </select> */}
      </div>
    </>
  );
};
